import { Node } from '@ekkogmbh/apisdk';
import { useCallback, useEffect, useState } from 'react';
import { ContentPanel, usePanel } from 'src/Common/Components/ContentControl/ContentPanel';
import { ReactivePanelColumn } from 'src/Common/Components/Stacks';
import { StyledTextField } from 'src/Common/Components/Forms/StyledTextField';
import { StyledFormHeader } from 'src/Common/Components/Forms/StyledFormHeader';

interface AreaPanelProps {
  closeHandler: () => void;
  saveHandler: (value: string) => void;
  node?: Node;
}

export const AreaPanel = ({ node, closeHandler, saveHandler }: AreaPanelProps): React.JSX.Element => {
  const { enableSave } = usePanel();
  const [value, setValue] = useState<string>('');

  const contentCallback = useCallback(
    () => (
      <ReactivePanelColumn>
        <StyledFormHeader label={'Add Node'} tooltip={'creates a new node within the current area'} />
        {node && <StyledTextField disabled label="Path" value={node.path + '/'} onChange={() => console.log('noop')} />}
        <StyledTextField label="Value" value={value} onChange={(e) => setValue(e.target.value)} />
      </ReactivePanelColumn>
    ),
    [node, value],
  );

  useEffect(() => {
    enableSave(value !== '');
  }, [value]);

  return (
    <ContentPanel
      steps={[
        {
          title: 'Add Node',
          contentCallback,
        },
      ]}
      onCancel={closeHandler}
      onSave={() => saveHandler(value)}
    />
  );
};
